export const IsTruthyComponent = {
  bindings: {
    val: '<'
  },
  transclude: {
    truthy: '?true',
    falsey: '?false'
  },
  template: `<ng-transclude ng-if="$ctrl.val" ng-transclude-slot="truthy"></ng-transclude>
             <ng-transclude ng-if="!$ctrl.val" ng-transclude-slot="falsey"></ng-transclude>`
};
